import LightmapImpl from './core/Lightmap';
export * from './core/Lightmap';
export const Lightmap = LightmapImpl;
